import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import JobOrderDrawer from "../om/job/modules/JobOrderDrawer";
import { formatDate } from '@/utils/util';
import warnDataModal from '@/views/online/component/warnDataModal';
export default {
  name: 'St21WarnList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    JobOrderDrawer: JobOrderDrawer,
    warnDataModal: warnDataModal
  },
  data: function data() {
    return {
      expandedRowState: true,
      expandedRowKeys: [],
      autoLoadInit: false,
      pagePath: '/online/warn',
      pageTitle: '数据报警',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      isorter: {
        column: 'warn_time',
        order: 'desc'
      },
      // 表头
      columns: [{
        dataIndex: 'warnTime',
        colName: 'warn_time',
        title: '报警时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorName',
        colName: 'factor_name',
        title: '因子名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorVal',
        colName: 'factor_val',
        title: '监测数值',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnContent',
        colName: 'warn_content',
        title: '报警内容',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnStatus_dictText',
        colName: 'warn_status',
        title: '报警状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkTime',
        colName: 'check_time',
        title: '解除时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkUserName',
        colName: 'check_user',
        title: '解除人',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        checkBatch: '/online/warn/checkBatch' // delete: '/online/warn/deleteBatch'

      }
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    },
    expandedRowState: function expandedRowState(value) {
      this.expandedData();
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    onToDetail: function onToDetail(data) {
      console.log('onToDetail', data);
      this.$refs.warnDataModalRef.onToChangeData(data);
    },
    loadData: function loadData(arg) {
      this.queryParam.category = '1';
      this.queryParam.st = window.sessionStorage.getItem('siteType');
      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
          _this.loadNums++;

          _this.expandedData();
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    expandedData: function expandedData() {
      var _this2 = this;

      this.expandedRowKeys = [];

      if (this.expandedRowState) {
        this.dataSource.forEach(function (item) {
          _this2.expandedRowKeys.push(item.id);
        });
      }
    },
    onDateWarnTime: function onDateWarnTime(value, dateArray) {
      this.queryParam.stime = dateArray[0];
      this.queryParam.etime = dateArray[1];
    },
    handleWarn: function handleWarn(record) {
      var param = {};
      param.siteId = record.siteId;
      param.originKey = '2';
      param.originId = record.id;
      var content = record.warnContent + ';';
      record.children.forEach(function (element) {
        content = content + element.factorName + element.warnContent + ';';
      });
      var title = formatDate(record.warnTime, 'yyyy-MM-dd');

      if (record.children.length == 1) {
        title += record.children[0].factorName + record.children[0].errorCode_dictText;
      } else if (record.children.length > 1) {
        title += '监测因子';
      }

      param.remark = content; //param.category = record.category

      param.title = title + record.warnContent;
      this.$refs.modalForm.edit(param);
      this.$refs.modalForm.title = '生成工单';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleCheck: function handleCheck(record) {
      var ids = record.id;
      var that = this;
      this.$confirm({
        title: '解除',
        content: '是否解除选中数据?',
        onOk: function onOk() {
          getAction(that.url.checkBatch, {
            ids: ids
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    batchCheck: function batchCheck() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '解除',
          content: '是否解除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            getAction(that.url.checkBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record); //console.log(record)

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
      this.$refs.modalForm.originKey = '2';
    }
  }
};